const CONTACT_BUTTON_MARGIN = 8;
export const MY_CONTACT_BUTTON_WIDTH = 104 + CONTACT_BUTTON_MARGIN;

export const ADD_CONTACT_BUTTON_WIDTH = 32 + CONTACT_BUTTON_MARGIN;

export const HEADER_LATERAL_PADDING = 32;

export const BG_MIN_HEIGHT = 82;

export const AVATAR_DESKTOP_SPACING_RIGHT = 16;
export const AVATAR_DESKTOP_INITIAL_SIZE = 96;
export const AVATAR_DESKTOP_TOTAL_WIDTH = AVATAR_DESKTOP_INITIAL_SIZE + AVATAR_DESKTOP_SPACING_RIGHT;
export const AVATAR_DESKTOP_INITIAL_TOP = 24;

export const AVATAR_MOBILE_INITIAL_SIZE = 80;

const CLOSE_BUTTON_SPACING_LEFT = 8;
export const CLOSE_BUTTON_WIDTH = 32;
export const CLOSE_BUTTON_TOTAL_WIDTH = CLOSE_BUTTON_WIDTH + CLOSE_BUTTON_SPACING_LEFT;

const CLOSE_BUTTON_HEIGHT = 32;
const CLOSE_BUTTON_SPACING_BOTTOM = 24;
export const CLOSE_BUTTON_TOTAL_HEIGHT = CLOSE_BUTTON_HEIGHT + CLOSE_BUTTON_SPACING_BOTTOM;
